import request from "@/utils/request";


/*
*舱单箱信息汇总
*/
export function getCdPlanMatchedDetailPaging(searchData) {
  return request({
    url: '/ilporder/getCdPlanMatchedDetailInfo',
    method: 'post',
    data: searchData
  })
}
